import { useState } from 'react';
import LessonPanels from './LessonPanels';
import { Journal, FileEarmarkText } from 'react-bootstrap-icons';

/** Sidebar around LessonPanels with built-in toggle behaviour */
export default function LessonSidebar({ visible, onToggle, lessonBlock, difficulty }) {
  const [activeTab, setActiveTab] = useState('lesson');

  if (!visible) {
    return (
      <button className="show-lesson-btn" onClick={onToggle} title="Show lesson panels">
        <Journal />
      </button>
    );
  }

  return (
    <div className="lesson-sidebar">
      <div className="lesson-sidebar-header">
        <div className="lesson-tabs">
          <div
            className={`lesson-tab ${activeTab === 'lesson' ? 'active' : ''}`}
            onClick={() => setActiveTab('lesson')}
          >
            <Journal className="lesson-tab-icon" />
            <span>Lesson Plan</span>
          </div>
          <div
            className={`lesson-tab ${activeTab === 'study' ? 'active' : ''}`}
            onClick={() => setActiveTab('study')}
          >
            <FileEarmarkText className="lesson-tab-icon" />
            <span>Study Sheet</span>
          </div>
        </div>
        <button className="sidebar-collapse-btn" onClick={onToggle} title="Hide lesson panels">
          ←
        </button>
      </div>
      <div className="lesson-sidebar-content">
        <LessonPanels
          lessonBlock={lessonBlock}
          difficulty={difficulty}
          isExpanded={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          noToggleButton={true}
        />
      </div>
    </div>
  );
}
